import React from 'react'
import { useEffect } from 'react'
import SetPage from '../../data/SetPage'
import { Helmet } from 'react-helmet'
const TermsPage = () => {

    
  useEffect(() => {
    SetPage("Terms")
    window.scrollTo(0, 0)
  }, [])


    return (
    <>
    <Helmet>‍
        <title>Terms and Conditions - SiliconMinds</title>‍
        <meta name="description" content="SiliconMinds Terms and Conditions" />       
        <meta name="twitter:card" content="" />   
        <meta name="twitter:site" content="@skillsuprise" />    
        <meta name="twitter:creator" content="@skillsuprise" />                
        <meta name="twitter:title" content="" />   
        <meta name="twitter:description" content="" />  
        <meta name="twitter:image" content=""/>     
        <meta property="og:title" content="" />  
        <meta property="og:description" content="" />        
        <meta property="og:image" content=""/>
        <meta property="og:url" content=""/>
        <meta property="og:site_name" content="Skills Uprise" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="fb:app_id" content="ID_APP_FACEBOOK" />
      </Helmet>
    
  <div className="w-100 ">


<div className=" bg-black p-5">

    <div className="flex-wrap container-xl">

<div className="col-lg-7 text-light">
<h4  className="sm-22">Legal</h4>
<h2  className="sm-22">Terms & Conditions</h2>
<p className="text-light">Last Update 31th May, 2023 </p>

</div>

    </div>

</div>

  <div className="flex-wrap  pt-5">

















               
               <div className="container-xl pb-5">




<div id="intro" className="account">
<h4  className="sm-22">Thanks for using SiliconMinds.</h4>

<h5  className="sm-18">Please read these Terms carefully.</h5>


 <h6  className="mt-4">By using SiliconMinds or signing up for an account, you’re agreeing to these Terms, which will result in a legal agreement between you and SiliconMinds (“Agreement”).</h6>

 <p>

 Welcome to siliconmindstech.com, (hereinafter referred to as the "Site" or as "SiliconMinds" interchangeably), a portal of SiliconMinds Services Private Limited (hereinafter referred to as SiliconMinds). These terms and conditions of use ("Terms") constitute a legal agreement between you and SiliconMinds. Use of this Site constitutes your unconditional acceptance of these Terms herein and by all terms, policies and guidelines incorporated by reference.
  These Terms apply to your use of this Site, and do not alter in any way the terms or conditions of any other agreement you may have with SiliconMinds, its subsidiaries or affiliates. If you are using the Site on behalf of any entity, you further represent and warrant that you are authorized to accept these Terms on such entity's behalf, and that such entity agrees to indemnify SiliconMinds for violations of these Terms. 
  If you do not agree with these terms, please do not use this Site.
<br/><br/>
Any individual and organisation wanting to make use of Site to post an internships/jobs (hereinafter referred to as the "Jobs") for self or for an organisation he/she represents is referred to as "Employer" or "Employers" as context may demand.
<br/><br/>
Any individual wanting to make use of Site to register for courses, workshops, hackathons or any such services provided by SiliconMinds is referred to as "Student" or "Students" as context may demand.
 <br/><br/>
 Any individual wanting to make use of Site to apply to Jobs listed on SiliconMinds is referred to as "Applicant" or "Applicants" as context may demand.
 </p>






</div>





<div>
<h4  className="sm-22">Registration Data and Account Security</h4>
<p>In consideration of your use of the Site, you agree to: (a) provide accurate, current and complete information about you as may be prompted by any registration forms on the Site ("Registration Data"); (b) maintain and promptly update the Registration Data, and any other information you provide to SiliconMinds, to keep it accurate, current and complete; (c) maintain the security of your password and identification; (d) notify SiliconMinds immediately of any unauthorized use of your account or any other breach of security; (e) accept all responsibility for any and all activities that occur under your account; and (f) accept all risks of unauthorized access to the Registration Data and any other information you provide to SiliconMinds. Please refer to our Privacy Policy for more details on how we collect, store, use, and retain your data on the Site.</p>
    </div>




<div className="mt-5">
<h4  className="sm-22">Most Important Terms & Conditions for Employers</h4>
<p>These Terms, specifically for Employers, are in addition to the other generic Terms & Conditions listed on the page which are common to all the users of the site and which you are required to go through. Any violation of these Terms may result in, but not limited to, an Employer's Job being declined for publication on SiliconMinds and/or his/her account being permanently blocked and/or appropriate legal action being initiated against him/her by SiliconMinds.</p>
    </div>








<div className="mt-5">
<h4  className="sm-22">Job Posting Terms and Conditions</h4>
<p>
It is your responsibility to ensure that you are authorized to post Jobs on your organization's behalf. Any dispute or legal claim arising out of unauthorized posting would be solely your liability and you indemnify SiliconMinds and SiliconMinds of any and all possible consequences of such actions.
If you upload your organization's logo while posting your Job or creating/updating your company profile, you are authorizing SiliconMinds to display it on our website along with Job post or in the list of our clients. It is your responsibility to ensure that you are duly authorized to share your organization logo with 3rd parties and allow them to use it.
SiliconMinds reserves the right to publish the Job post of Employers on its social media handles and job board partners like LinkedIn, Indeed etc., and in newspapers in order to increase the visibility of the Job post.
You must provide accurate and complete details about the organization and the Job. Any act of misinformation or hiding material information would result in your account being permanently blocked or any other suitable action as deemed fit by SiliconMinds.
You may be asked for documents in the name of your company for our first-time user authentication process. This information will only be used for authentication purposes and will not be used anywhere else in any form.
You may also complete the one-time authentication process by signing-in to your company's YouTube channel. This will be governed by the YouTube Terms of Service.
The minimum stipend criteria for an in-office internship is Rs. 2000/Month and for a work from home internship is Rs. 1000/Month. The minimum CTC criteria for a full time job post is 3 LPA.

    
</p>
    </div>




<div className="mt-5">
<h4  className="sm-22">SiliconMinds doesnot allow</h4>
<p>
Unpaid internships, except for NGOs/NPOs & some niche profiles (Law, Experimental Physics, Library Science, and the likes).
Training program and any such program where Applicants are expected to pay a security deposit or an admission fee. To charge money in any form (including test fee, security deposit, documentation fee etc.) from the Applicants for offering Job is strictly prohibited.
Modelling Jobs from lesser known companies.
Network Level Marketing (NLM) jobs/internships where applicants/individuals have to use their personal connections and personal social media accounts to promote a business.
Any Job where there is a possibility of an Applicant consuming alcohol or smoking or inducing others to do so, as the majority of our users are underage.
Individuals or organisations promoting explicit religious content, a particular religious personality or a sect etc. are not allowed to post Jobs on SiliconMinds.
Businesses promoting or dealing in gambling, porn, and other prohibited/illegal/age inappropriate activities.
Third party Job posting. You can post Jobs only for the organization that you directly work for. Recruiting agencies or any third party agencies are not authorized to post Jobs on their clients' behalf.
</p>
    </div>


<div className="mt-5">
<h4  className="sm-22">Hiring Terms and Conditions</h4>
<p>It is your responsibility to ensure that there is no material difference between the Job details that are advertised on SiliconMinds and the details that are communicated to Applicants later in the selection process (pre-interview, in offer letter etc.). Any ‘negative' material difference (such as offered stipend being lower than what was advertised) will result in suitable action being taken by SiliconMinds against you.
Any assignment(s) that you may give to Applicants to assess their suitability for the Job should be fair and relevant to the Job profile. Any attempt to get work done for free from Applicants disguised as assessment or to get them to download or generate downloads for your app or get likes/shares/comments etc. for your social media handles only for the purpose of getting free publicity disguised as an assignment are strictly prohibited and would invite suitable actions against you.
All your communications with Applicants (through SiliconMinds Chat or otherwise) should be professional and must not contain any obscene or offensive content.
Once you hire any Applicant(s) for your Job, you must provide them with an offer letter clearly detailing all the important details of the Job (such as role & responsibilities, remuneration, and payment mechanism) and complete address and contact details of your organisation.
You must pay the promised remuneration to the selected Applicants in a timely manner as per agreed terms and conditions in the offer letter. Non payment of the remuneration or delayed payment of the remuneration is strictly prohibited and would invite suitable action against you.
You must respond within 72 working hours to any Applicant complaints regarding your Job that we may bring to your notice. Failure to do so may result in a temporary or permanent suspension of your SiliconMinds account depending on the nature of the complaint.
If you come across any suspicious activity, content or behaviour on SiliconMinds by an Applicant or another user, you must report it to SiliconMinds immediately so that necessary actions can be taken.
While we put our best efforts to reach out to the best talent available in the country, posting your Job on SiliconMinds does not guarantee hiring.
</p>
    </div>








<div className="mt-5">
    <h4  className="sm-22">Applicant's Data usage</h4>
<p>
You can use the Applicants' data that you receive for your Job solely for the purpose of hiring. Any attempt to send any other communication (promotional content for example) to the Applicants or any other usage of the data is strictly prohibited.
You are strictly prohibited from transferring/selling/sharing Applicants' data, for free or for a fee, to any other entity. Any such attempt would result in your account on SiliconMinds being permanently blocked and would be liable for legal action against you and your organization.
    </p>

    </div>



<div className="mt-5">
<h4  className="sm-22">Payments and Refunds</h4>
<p>


Payments for the services offered by SiliconMinds shall be on a 100% advance basis.
Refund if any will be as per our Refund Policy.
SiliconMinds offers no guarantees whatsoever for the accuracy or timeliness of the refunds reaching the Employers card/bank accounts.
</p>
    </div>













<div className="mt-5">

    <h4  className="sm-22">Important terms for applicants</h4>
    <p>

    These Terms, specifically for Applicants, are in addition to the other generic Terms & Conditions listed on the page which are common to all the users of the site and which you are required to go through. Any violation of these T&Cs may result in, but not limited to, an applicant's Job application being declined and/or his/her account being permanently blocked and/or suitable legal action being initiated against him/her by SiliconMinds.

If you have applied for a Job on SiliconMinds and receive a communication from SiliconMinds or Employer regarding your application, you must respond to it with-in 72 hours.
Once you accept a Job offer, you must make every possible effort to join and start the Job on time. To not show up or to decline an earlier accepted Job offer at the last moment, or to go incommunicado creates a very poor impression of you in front of the Employer and reduces the credibility of the Applicant community at large. Any such behaviour will not only result in your account being blocked on SiliconMinds but we will also report it to your college administration wherever applicable.
You must provide accurate and complete information at the time of Job application or creating an account on SiliconMinds – any misrepresentation of information, or hiding of material information, or impersonation would result in your account being blocked on the site and you being reported to your college administration wherever applicable.
You must pay attention to a Job's complete details (profile, location, remuneration, skills required, etc.) before applying for it. Irrelevant applications will result in your account being penalized (we may stop you from applying to future Jobs or block your account all together)
You are strictly prohibited from transferring/selling/sharing Employers' data (contact details etc.), for free or for a fee, with any other entity. Any such attempt would result in your account on SiliconMinds being permanently blocked and would be liable for legal action against you.
SiliconMinds community is a community of sincere users who are known for and are expected to demonstrate high standards of professionalism in their dealings with other users and Employers – you are required to maintain these standards and decorum of the community. All your communications with other users of SiliconMinds (through SiliconMinds Chat or otherwise) should be professional and must not contain any obscene or offensive content.
You agree to have gone through the ‘Safety Tips for Applicants' section of these Terms and have understood the same.
While it is our endeavor to provide you with accurate and reliable Job information; it is always possible for an error to occur. Hence, you must conduct your own due diligence and research about an employer or organisation before starting a Job and take full responsibility of the same. You further agree to have read and understood the ‘Disclaimers' section of these Terms and explicitly and specifically agree to it.
If you come across any suspicious activity, content or behaviour on SiliconMinds by an Employer or another user, you must report it to SiliconMinds immediately so that necessary actions can be taken – this is both your duty and obligation.
While we make our best efforts to bring you the best Job opportunities possible, SiliconMinds does not guarantee a Job to a student.
Upon registration, your registered email id and phone number will be automatically subscribed to receive email and SMS notifications from SiliconMinds. You may opt out of it anytime.
    </p>
</div>





<div className="mt-5">
<h4  className="sm-22">Safety tips for applicants</h4>
<p>
It is our endeavor to provide all our users with a safe and hassle free experience on SiliconMinds. Accordingly, we would like to make Applicants aware of following safety tips for them.
</p>
</div>



<div className="mt-5">
    <h6 className="sm-22">SiliconMinds doesnot allow employees to</h6>
    <p>

    Offer unpaid Jobs, unless explicitly mentioned so in the Job post.
Post training program and any such program where Applicants are expected to pay a security deposit or an admission fee.
To charge money in any form (including test fee, security deposit, documentation fee etc.) from the Applicants for offering Job. This is strictly prohibited.
Offer modelling Jobs from lesser known companies.
Offer Network Level Marketing (NLM) jobs/internships where applicants/individuals have to use their personal connections and personal social media accounts to promote a business.
Offer any Job where there is a possibility for an Applicant consuming alcohol or smoking or inducing others to do so, as the majority of our users are underage.
Offer Jobs from individuals or organisations promoting explicit religious content, a particular religious personality, or a sect etc.
Offer Jobs at businesses promoting or dealing in gambling, porn, and other prohibited/illegal/age inappropriate activities.
Make third party Job posting. An Employer can post Jobs only for the organization that he/she directly works for. Recruiting agencies or any third party agencies are not authorized to post Jobs on their clients' behalf.
    </p>
</div>

<div className="mt-5">
    <h6 className="sm-22">Further, it is mandatory for Employers to ensure that :</h6>
    <p>
    Jobs details communicated to Applicants at any stage are same as advertised on SiliconMinds and there is no negative material difference (Ex. - offering lower or no stipend than what was advertised on SiliconMinds).
Any assignment(s) that they may give to Applicants to assess their suitability for the Job should be fair and relevant to the Job profile. Any attempt to get work done for free from Applicants disguised as assessment or to get them to download or generate downloads for an app or get likes/shares/comments etc. for Employer's social media handles only for the purpose of getting free publicity disguised as an assignment are strictly prohibited.
All their communications with Applicants (through SiliconMinds Chat or otherwise) are professional and must not contain any obscene or offensive content.
Once they hire any Applicant(s) for their Job, they must provide them with an offer letter clearly detailing all the important details of the Job (such as role & responsibilities, remuneration, and payment mechanism) and complete address and contact details of Employer.
They pay the promised remuneration to the selected Applicant(s) in a timely manner as per agreed terms and conditions of the Job as detailed in the offer letter.
    </p>

    <p>If you come across any example of any Employer violating these guidelines, you must report it to SiliconMinds using Help Center so that we can investigate and take appropriate actions.</p>
</div>



<div className="mt-5">
    <h4  className="sm-22">Disclaimers</h4>
    <p>
    This Site and its content are provided "as is" and SiliconMinds and its directors, employees, content providers, agents and affiliates exclude, to the fullest extent permitted by applicable law, any warranty, express or implied, including, without limitation, any implied warranties of merchantability, satisfactory quality or fitness for a particular purpose. SiliconMinds will not be liable for any damages of any kind arising from the use of this site. The functions embodied on or in the materials of this site are not warranted to be uninterrupted or without error. You, not SiliconMinds and/or SiliconMinds, assume the entire cost of all necessary care or correction due to your use of this site or content. SiliconMinds makes no warranty that the site or the content is free from infection by viruses or anything else that has contaminating or destructive properties. SiliconMinds uses reasonable efforts to ensure the accuracy, correctness and reliability of the Content, but we make no representations or warranties for the same. Images of people or places displayed on the Site are either the property of, or used with permission by, SiliconMinds or third parties. The use of these images by you, or anyone else authorized by you, is prohibited unless specifically permitted by these Terms or specific permission provided elsewhere on the Site or by separate license or agreement. Any unauthorized use of these images may violate copyright laws, trademark laws, the laws of privacy and publicity, and other applicable laws.
        </p>
</div>









<div className="mt-5">
    <h4  className="sm-22">Rights to Website and Contents thereof</h4>
    <p>
    This Site is owned and operated by SiliconMinds. All the content featured or displayed on this Site, including, but not limited to, text, graphics, data, images(photographic and moving), illustrations, software and selection and arrangement thereof ("Content"), is owned by SiliconMinds. All elements of this Site, including, but not limited to, the general design and the Content thereof, are protected by copyright, moral rights, trademark and other laws related to the protection of intellectual property rights. Except for, as explicitly permitted under this, or other written license or agreement with SiliconMinds, no portion or element of this Site or its content may be copied or retransmitted via any means. All related rights shall remain the exclusive property of SiliconMinds, its licensors or its third-party image partners.
    </p>
</div>


<div className="mt-5">
    <h4  className="sm-22">Using the Website</h4>
    <p>
    This Site and its Content are intended for Users of siliconmindstech.com, the division of SiliconMinds. You may not use this Site or the content for any purpose, which is not related to your business with siliconmindstech.com. Any use of the Content, this Site or any of its functionality for a purpose not permitted by these Terms is grounds for the immediate revocation of any usernames, pass codes or other permissions that may have been granted by siliconmindstech.com on behalf of SiliconMinds for use of this Site. You are specifically prohibited from: (i) downloading, copying, or retransmitting any or all of the Site or the Content without, or in violation of, a written license or agreement with SiliconMinds; (ii) using any data mining or similar data gathering or extraction methods; (iii) manipulating or otherwise displaying the site or the content by using, framing or similar navigational technology; (iv) registering, subscribing, unsubscribing, or attempting to register, subscribe any party for any the site if you are not expressly authorized by such party to do so; and (v) using the Site or Content other than for its intended purpose. Such unauthorized use may also violate applicable laws including without limitation copyright and trademark laws, the laws of privacy and publicity, and applicable communications regulations and statutes. You represent and warrant that you will comply with all applicable regulations, including, without limitation, those relating to the internet, data, e-mail, privacy and the transmission of technical data exported from India or the Country in which you reside.
    </p>
</div>



<div className="mt-5">
    <h4  className="sm-22">Trademarks</h4>
    <p>
    SiliconMinds’s Trademarks, the SiliconMinds’s and SiliconMinds logo, and any other product or service name or slogan contained in the Site are trademarks of SiliconMinds and its suppliers or licensors, and may not be copied, imitated or used, in whole or in part, without the prior written permission of SiliconMinds or the applicable trademark holder. You may not use meta-tags or any other "hidden text" utilizing content or any other name, trademark or product or service name of SiliconMinds without our prior written permission. In addition, the look and feel of the Site, including all page headers, Site name and logo, custom graphics, button icons and scripts, is the service mark, trademark and/or trade dress of SiliconMinds and may not be copied, imitated or used, in whole or in part, without our prior written permission. All other trademarks, registered trademarks, product names and company names or logos mentioned in the Site are the property of their respective owners. Reference to any products, services, processes or other information, by trade name, trademark, manufacturer, supplier or otherwise does not constitute or imply endorsement, sponsorship or recommendation thereof by us.
    </p>
</div>



<div className="mt-5">
    <h4  className="sm-22">Indemnity</h4>
    <p>
    You agree to defend, indemnify and hold harmless SiliconMinds, its subsidiaries, affiliates, licensors, employees, agents, third party information providers and independent contractors against any claims, damages, costs, liabilities and expenses (including, but not limited to, reasonable attorneys' fees) arising out of or related to any User Content that you post, store or otherwise transmit on or through the Site, your conduct, your use or inability to use the Site, your breach or alleged breach of the Site Terms or of any representation or warranty contained herein, your unauthorized use of the Content, or your violation of any rights of another. Further you shall indemnify SiliconMinds, its subsidiaries, its affiliates and licensors against any loss, expense, cost or damage incurred by any or all of them as a result of your breach of these Terms or your unauthorized use of the Content or the Site.
    </p>
</div>




<div className="mt-5">
    <h4  className="sm-22">Termination</h4>
    <p>Notwithstanding any of these Site Terms, SiliconMinds reserves the right, without notice and in its sole discretion, to terminate your account and/or to block your use of the Site.</p>
</div>





<div className="mt-5">
    <h4  className="sm-22">Change to Site terms</h4>
    <p>
    SiliconMinds reserves the right to change any of the terms and conditions contained in the Site Terms or any policy or guideline of the Site, at any time and in its sole discretion. Any changes will be effective immediately upon posting on the Site. Your continued use of the Site following the posting of changes will constitute your acceptance of such changes. We encourage you to review the Site Terms whenever you visit the website.
    </p>
</div>



<div className="mt-5">
    <h4  className="sm-22">Chargeback</h4>
    <p>You hereby expressly agree that once you or any other person have started the process of downloading content from the site by expressly, without reservation, agreeing to the terms and conditions of the site and license agreement, by clicking and accepting them and have further submitted your credit card/ any other card details to the site/internet banking service provider for payment and your account gets debited no chargeback claim/dispute with regard to the failure of delivery of Product/ Content or the use/misuse of such credit card or any other card, filed by you/on your behalf with the Credit Card Provider/Internet banking service provider or any Bank/Financial Institution shall be binding on SiliconMinds or SiliconMinds’s Merchant Bank. You accept and take full responsibility towards the ownership/possession and use of your credit card or any other card. You expressly waive and consciously give up any/all rights you may have in law or in any agreement between you and the credit card or any other card provider/internet service provider or under network rules and regulations to raise any dispute to claim any charge back or any process fee from any Bank/Financial Institution/ Internet banking service provider affecting SiliconMinds in any manner pecuniary or otherwise on any grounds whatsoever including non delivery of Product/Content or fraudulent or improper transactions by the unauthorized/improper use of your credit/debit card or any other card. This understanding that you will have no right to claim any chargeback is a material condition of this agreement and once you hereby expressly agree to it you shall be stopped from challenging/disputing it in any adjudication/proceeding before any Bank/Financial institution/ Internet banking service provider or Court or otherwise. Without prejudice to SiliconMinds’s right to defend its interest(s), SiliconMinds shall not be made a party to any chargeback proceedings before any Bank/Financial institution/ Internet banking service provider or court and in no case be required to prove the transaction effected by the use of your credit/debit or any other card was legitimate and genuine, or that SiliconMinds has actually provided you the downloaded content. Please refer to our Refund & Cancellation policy for more details.</p>
</div>





<div className="mt-5">
    <h4  className="sm-22">Severance & Waiver</h4>
    <p>No action of SiliconMinds, other than an express written waiver or amendment, may be construed as a waiver or amendment of any of these Terms. If any clause in these Terms is found to be unenforceable, wherever possible, it will not affect any other clause and each will remain in full force and effect. We reserve the right to change these Terms, the Content displayed on the Site, any license contained on the Site and any other information or license terms without prior notice. These Terms set out the entire agreement between SiliconMinds and you relating to your use of this Site. Any rights not expressly granted herein are reserved.</p>
</div>


<div className="mt-5">
    <h4  className="sm-22">Jurisdiction</h4>
    <p>All license agreements, use or any issues arising out of any activity regarding the use of this website will be governed by the laws of India and subject to the exclusive jurisdiction of courts in Gurugram.</p>
</div>








































               </div>
               
               
               
               
               </div> 

  </div>
    </>
    )
}

export default TermsPage
